<template>
  <div class="container">
    <div :class="`card ${id % 2 === 0 ? 'card-one' : 'card2'}`">
      <h2>{{ title }}</h2>
      <i class="fas fa-arrow-right"></i>
      <!-- <p>a lonely trip.</p> -->
      <div class="pic" :style="`background-image : url(${img})`"></div>
      <ul>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <div class="social">
        <i class="fab fa-facebook-f"></i>
        <i class="fab fa-twitter"></i>
        <i class="fab fa-instagram"></i>
        <i class="fab fa-github"></i>
      </div>

      <a :href="`post/${id}`">
        <button>{{ subscribed ? 'Read' : 'Premium' }}</button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'postSnippet',
  data() {
    return {
      subscribed: null,
    };
  },
  props: {
    title: {
      type: String,
    },
    img: {
      type: String,
    },
    id: {
      type: Number,
    },
  },
  mounted() {
    const getCookie = (name) => {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    };
    this.subscribed = getCookie('customerId');
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
i {
  opacity: 0;
  font-size: 18px;
  color: #fff;
  will-change: transform;
  -webkit-transform: scale(0.1);
  transform: scale(0.1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
h2 {
  pointer-events: none;
}
body {
  background-color: #e6e5e1;
  width: 100vw;
  height: 100vh;
}
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.container .card {
  position: relative;
  width: 500px;
  height: 200px;
  background-color: #fff;
  overflow: hidden;
  margin-bottom: 4px;
}
.container .card:before {
  content: '';
  z-index: 99;
  position: absolute;
  top: -10px;
  left: 32px;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background-color: #e6e5e1;
}
.container .card:after {
  content: '';
  z-index: 99;
  position: absolute;
  bottom: -10px;
  left: 32px;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background-color: #e6e5e1;
}
.container .card ul {
  z-index: 99;
  position: absolute;
  left: 39px;
  top: 5px;
  list-style-type: none;
}
.container .card ul li {
  width: 2px;
  height: 2px;
  border-radius: 2px;
  margin: 6px 0;
  background-color: #e6e5e1;
}
.container .card h2 {
  z-index: 99;
  font-family: 'Poppins', sans-serif;
  position: absolute;
  bottom: 0;
  right: 130px;
  font-size: 60px;
  font-weight: 700;
  color: #fff;
}
.container .card .fa-arrow-right {
  z-index: 100;
  position: absolute;
  right: 75px;
  bottom: 25px;
  font-size: 40px;
  cursor: pointer;
}
.container .card p {
  z-index: 99;
  position: absolute;
  top: 20px;
  right: 70px;
  color: #333;
  opacity: 0.7;
  font-size: 12px;
  letter-spacing: 1px;
  writing-mode: vertical-lr;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .card .pic {
  z-index: 100;
  width: 400px;
  height: 200px;
  background-image: url('https://images.unsplash.com/photo-1525543907410-b2562b6796d6?ixlib=rb-0.3.5&s=9ff8e5e718a6a40cbd0e1471235912f4&auto=format&fit=crop&w=3452&q=80');
  background-size: 100% 100%;
  filter: grayscale(100%);
}
.container .card .social {
  position: absolute;
  left: 60px;
  top: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 180px;
  height: 64px;
  border-radius: 80px;
}
.container .card .social i:nth-of-type(1) {
  -webkit-transition-delay: 0.4s;
  transition-delay: 0.4s;
}
.container .card .social i:nth-of-type(2) {
  -webkit-transition-delay: 0.3s;
  transition-delay: 0.3s;
}
.container .card .social i:nth-of-type(3) {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
.container .card .social i:nth-of-type(4) {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}
.container .card:hover i {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.container .card button {
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: 67px;
  height: 30px;
  background-color: #da4d1d;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
  mix-blend-mode: hard-light;
}
.container .card button i {
  font-size: 3rem;
}
.container .card:hover button {
  transform: scale(16.5);
}
.container .card:hover p {
  color: #fff;
}
.container .card:hover .pic {
  filter: grayscale(0);
}
.container .card2 .pic {
  background-image: url('https://images.unsplash.com/photo-1528785198459-ec50485704c7?ixlib=rb-0.3.5&s=3a2fc3039516555bbb2e9cd2967bd321&auto=format&fit=crop&w=1537&q=80');
}
.container .card2 button {
  background-color: #2b26c3;
}
.dr {
  position: absolute;
  bottom: 16px;
  right: 16px;
  width: 100px;
}
</style>
